var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 47.6666C37.8591 47.6666 47.6663 37.8593 47.6663 25.9999C47.6663 14.1189 37.8591 4.33325 25.9781 4.33325C14.1187 4.33325 4.33301 14.1189 4.33301 25.9999C4.33301 37.8593 14.1403 47.6666 25.9997 47.6666ZM19.8647 34.4678C18.8495 34.4678 18.3958 33.9062 18.3958 33.1069V18.8713C18.3958 18.0504 18.8495 17.5104 19.8647 17.5104H22.0681C23.0834 17.5104 23.5371 18.0504 23.5371 18.8713V33.1069C23.5371 33.9062 23.0834 34.4678 22.0681 34.4678H19.8647ZM29.9312 34.4678C28.9159 34.4678 28.4407 33.9062 28.4407 33.1069V18.8713C28.4407 18.0504 28.9159 17.5104 29.9312 17.5104H32.113C33.1283 17.5104 33.5819 18.0504 33.5819 18.8713V33.1069C33.5819 33.9062 33.1283 34.4678 32.113 34.4678H29.9312Z",
    fill: "#282829",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.8825db16d1fedd02988371ded3940e16.svg";
export { ForwardRef as ReactComponent };